import React from 'react';
import Users from './Users';
export default function Admin() {
    return (
        <div>
            <Users></Users>
        </div>
    );
}
